export enum UserSubscriptionType {
    Annual = 0,
    Monthly = 1,
}
